import React, { Fragment, Component } from 'react'
import axios from 'axios'
import { getApiBaseUrl } from '../utils/api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class RealEstate extends Component {
    
    constructor(){
        super();
        this.state={
            name: '',
            mobileno: '',
            email:'',
            budget:'',
            location:''
        }
    }

    onChangeInput = (e) => {
        const re = /^[0-9\b]+$/;
        if(e.target.name === "name"){
          this.setState({
              name: e.target.value
          });
        } else if(e.target.name === "mobileno" && (re.test(e.target.value) || e.target.value === "") && e.target.value.length <= 10){
            this.setState({
                mobileno: e.target.value
            });
         } else if(e.target.name === "email"){
             this.setState({
                 email: e.target.value
             });
         } else if(e.target.name === "budget" && (re.test(e.target.value) || e.target.value === "")){
             this.setState({
                budget: e.target.value
             });
         } else if(e.target.name === "location"){
            this.setState({
                location: e.target.value
            });
        }
    }
    
    onSendMessage = async () => {
        let enquiryDetail = {
            Name: this.state.name,
            MobileNumber: this.state.mobileno,
            EmailId: this.state.email,
            Budget: this.state.budget,
            Location: this.state.location
        };
        if(enquiryDetail.Name.length == 0 || enquiryDetail.MobileNumber.length == 0 || enquiryDetail.EmailId.length == 0){
            toast.warning("Please enter Name, Mobile Number and EmailId");
            return;
        }
        await axios.post(`${getApiBaseUrl()}/hj-enquiry/createRealestateEnq`,enquiryDetail)
            .then((res) => {
                toast.success("Insurance Enquiry saved Successfully! Our executive will contact you as soon as possible.");
                this.clearForm();
            }).catch((error) => {
                console.log(error);
            });
    }
    clearForm = async () =>{
        this.setState({
            name: '',
            mobileno: '',
            email:'',
            budget:'',
            location:''
        })
    }
    render(){
        return (
            <Fragment>
                <ToastContainer />
                <div className="boxed_wrapper ltr">
                    {/* Mobile Menu  */}
                    <div className="mobile-menu">
                    <div className="menu-backdrop"></div>
                    <div className="close-btn"><i className="fas fa-times"></i></div>

                    <nav className="menu-box">
                        <div className="nav-logo"><a href="/"><img src="assets/images/logo-4.png" alt="H.J. Enterprises" title=""/></a></div>
                        <div className="menu-outer">{/*Here Menu Will Come Automatically Via Javascript / Same Menu as in Header*/}</div>
                    </nav>
                    </div>{/* End Mobile Menu */}


                    {/* page-title */}
                    <section className="page-title centred">
                    <div className="bg-layer" style={{backgroundImage: "url(assets/images/background/page-title.jpg)"}}></div>
                    <div className="pattern-layer">
                        <div className="pattern-1" style={{backgroundImage: "url(assets/images/shape/shape-18.png)"}}></div>
                        <div className="pattern-2" style={{backgroundImage: "url(assets/images/shape/shape-17.png)"}}></div>
                    </div>
                    <div className="auto-container">
                        <div className="content-box">
                            <h1>Real State</h1>
                        </div>
                    </div>
                    </section>
                    {/* page-title end */}

                    {/* about-style-two */}
                    <section className="about-style-two pt_30 pb_10">
                        <div className="auto-container">
                            <div className="row align-items-center">
                                <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                                    <section className="faq-form-section pt_10 pb_50">
                                        <div className="auto-container" id="register-form-realstate">
                                            <div className="sec-title mb_10 centred">
                                                <h2>Register Form</h2>
                                            </div>
                                            <div className="form-inner">
                                                <div className="row clearfix">
                                                    <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                                                        <input 
                                                            type="text" 
                                                            name="name" 
                                                            placeholder="Your Full Name" 
                                                            required=""
                                                            onChange={this.onChangeInput}
                                                            value={this.state.name}
                                                        />
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                                        <input 
                                                            type="text" 
                                                            name="mobileno" 
                                                            placeholder="Mobile Number" 
                                                            required=""
                                                            onChange={this.onChangeInput}
                                                            value={this.state.mobileno}
                                                        />
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                                        <input 
                                                            type="email" 
                                                            name="email" 
                                                            placeholder="Your Email" 
                                                            required=""
                                                            onChange={this.onChangeInput}
                                                            value={this.state.email}
                                                        />
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                                        <input 
                                                            type="text" 
                                                            name="location" 
                                                            placeholder="Location" 
                                                            required=""
                                                            onChange={this.onChangeInput}
                                                            value={this.state.location}
                                                        />
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                                        <input 
                                                            type="text" 
                                                            name="budget" 
                                                            placeholder="Budget" 
                                                            required=""
                                                            onChange={this.onChangeInput}
                                                            value={this.state.budget}
                                                        />
                                                    </div>

                                                    <div className="col-lg-12 col-md-12 col-sm-12 form-group message-btn centred">
                                                        <button type="submit" className="theme-btn btn-one" onClick={this.onSendMessage}>Send Message</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>

                                </div>
                                <div className="col-lg-6 col-md-12 col-sm-12 image-column">
                                    <div className="image_block_two">
                                        <div className="image-box">
                                            <div className="image-shape">
                                                <div className="shape-3" style={{backgroundImage: "url(assets/images/shape/shape-11.png)"}}></div>
                                                <div className="shape-4" style={{backgroundImage: "url(assets/images/shape/shape-3.png)"}}></div>
                                            </div>
                                            <figure className="image"><img src="assets/images/resource/about-4.jpg" alt=""/></figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* about-style-two end */}




                    {/* main-footer */}
                    <footer className="main-footer">
                        <div className="footer-bottom centred">
                            <div className="auto-container">
                                <div className="copyright"><p>Design by : <a href="index.html">SK Computer Solution</a></p></div>
                            </div>
                        </div>
                    </footer>
                    {/* main-footer end */}

                    {/*Scroll to top*/}
                    <div className="scroll-to-top">
                        <div>
                            <div className="scroll-top-inner">
                                <div className="scroll-bar">
                                    <div className="bar-inner"></div>
                                </div>
                                <div className="scroll-bar-text">Go To Top</div>
                            </div>
                        </div>
                    </div>
                    {/* Scroll to top end */}
                </div>
            </Fragment>
        )
    }
}

export default RealEstate;